import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useCart } from '../../store/cart.store';
import ModalWrapper from '../Modals/ModalWrapper';
import ClearCart from '../Common/ClearCart';

const Head = () => {
    const [clear, setClear] = useState(false)
    return (
        <>
        <Box>
            <Box sx={{display:'flex', gap:'5px', alignItems:'center', padding:'0 10px'}}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Component 2">
                    <path
                        id="Icon"
                        d="M20.5 7.27774L12 12M12 12L3.49997 7.27774M12 12L12 21.5M21 16.0585V7.94144C21 7.5988 21 7.42747 20.9495 7.27468C20.9049 7.1395 20.8318 7.01542 20.7354 6.91073C20.6263 6.79239 20.4766 6.70919 20.177 6.54279L12.777 2.43168C12.4934 2.27412 12.3516 2.19534 12.2015 2.16445C12.0685 2.13712 11.9315 2.13712 11.7986 2.16445C11.6484 2.19534 11.5066 2.27412 11.223 2.43168L3.82297 6.54279C3.52345 6.70919 3.37369 6.79239 3.26463 6.91073C3.16816 7.01542 3.09515 7.1395 3.05048 7.27468C3 7.42748 3 7.5988 3 7.94144V16.0585C3 16.4012 3 16.5725 3.05048 16.7253C3.09515 16.8605 3.16816 16.9846 3.26463 17.0893C3.37369 17.2076 3.52345 17.2908 3.82297 17.4572L11.223 21.5683C11.5066 21.7259 11.6484 21.8046 11.7986 21.8355C11.9315 21.8629 12.0685 21.8629 12.2015 21.8355C12.3516 21.8046 12.4934 21.7259 12.777 21.5683L20.177 17.4572C20.4766 17.2908 20.6263 17.2076 20.7354 17.0893C20.8318 16.9846 20.9049 16.8605 20.9495 16.7253C21 16.5725 21 16.4012 21 16.0585Z"
                        stroke="#2F4B6C"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Icon_2"
                        d="M16.5 9.5L7.5 4.5"
                        stroke="#2F4B6C"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    </g>
                </svg>
                <Typography color='#154D72' fontSize={'20px'} fontWeight={700} lineHeight={'28px'}>
                הזמנה חדשה
                </Typography>
            </Box>
            <Box sx={{padding:'10px'}}>
                <Box sx={{display:'flex', gap:'5px'}} onClick={() => setClear(!clear)}>
                    <Typography color='info' sx={{textDecoration:'underline', cursor:'pointer'}}>
                    איפוס הזמנה
                    </Typography>
                    <img src={`${process.env.REACT_APP_MEDIA}/clearCart.svg`} />
                </Box>
            </Box>
        </Box>
        <ModalWrapper 
            active={clear} 
            setActive={setClear}
            component={
                <Typography color='info' fontSize={'20px'} fontWeight={700} lineHeight={'28px'}>
                    איפוס הזמנה
                </Typography>
            }
        >
            <ClearCart closeFunc={() => setClear(false)}/>
        </ModalWrapper>
        </>
    );
};

export default Head;